import React,
{
    useEffect,
    useState,

} from 'react'
import {
    Menu,
    Grid,
    Badge,
    Theme,
    AppBar,
    Avatar,
    Toolbar,
    MenuItem,
    IconButton,
    makeStyles,
    createStyles,

} from '@material-ui/core';
import 'firebase/auth';
import Logo from '../Common/Images/logo.png';
import Firebase from 'firebase/app';
import LogoType from '../Common/Images/logoType.png';
import { useAuthState } from 'react-firebase-hooks/auth';
import {useDocumentData} from 'react-firebase-hooks/firestore';
import {deleteCache} from "../Common/Helper/Storage";
import NotificationsIcon from '@material-ui/icons/Notifications';
import {NotInterestedTwoTone} from "@material-ui/icons";
import NotificationPage from "../Notifications/NotificationPage";
export const Header = (props: any) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [user, authLoading, authError] = useAuthState(Firebase.auth());
    const [jasperCard, jasperCardLoading, jasperCardError] = useDocumentData<any>(
        user ?
            Firebase.firestore()
                .collection('users')
                .doc(user ? user.uid : 'null')
                .collection('JasperCard')
                .doc('Card')
            : null
    );

    const classes = useStyles();
    const open = Boolean(anchorEl);
    const handleMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const [openNotifications, setOpenNotifications] = useState(false);
    const [unreadMessageCount, setUnreadMessageCount] = useState(0);
    const dismissNotifications = () => {
        setOpenNotifications(false);
    }

    const onMessagesLoad = ({unread, error}) => {
        if (error) {
            // console.log(error);
            return;
        }
        setUnreadMessageCount(unread)
    }
    useEffect( () => handleClose(), [user]);

    return (
        <>
        <AppBar
            position={'static'}
            className={classes.main}
        >
            <Toolbar>
                <Grid container
                    justify={'space-between'}
                      alignItems={'center'}
                >
                    <Grid item>
                        <Grid container
                              alignItems={'center'}
                        >
                            <Grid item>
                                <img
                                    className={classes.logo}
                                    src={Logo}
                                    alt="logo" />
                        </Grid>
                            <Grid item>
                                <img
                                    className={classes.logoType}
                                    src={LogoType}
                                    data-tutorial={"tut-1"}
                                    />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                    </Grid>
                <Grid item>
                    { user &&
                        <>
                            <Badge
                                invisible={unreadMessageCount == 0}
                                badgeContent={unreadMessageCount}
                                overlap={'circle'}
                                color={'secondary'}
                            >
                                <IconButton onClick={() =>{
                                    setOpenNotifications(true)
                                    Firebase.analytics().logEvent('Notifications', {page_location:  'Dashboard/notifications', page_title: 'Notification'});
                                }}>
                                    <NotificationsIcon className={classes.notificationIcon}/>
                                </IconButton>
                            </Badge>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={(handleMenu)}
                                color="inherit"
                                edge={'end'}
                            >
                                <Avatar src={ jasperCard ? `https://mcbannerimg.imgix.net/${jasperCard.pidm}`: undefined} />
                            </IconButton>
                    </>
                    }
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => {
                            Firebase.auth().signOut().then(function () {

                                deleteCache('Employees');
                                deleteCache('Quick Links');
                                deleteCache('Covid');
                                //@ts-ignore
                                if(window.webkit)
                                    //@ts-ignore
                                    window.webkit.messageHandlers.signOut.postMessage({body: true})

                                

                            }).catch(function(error){

                            })
                        }
                        }>logout</MenuItem>
                    </Menu>
                </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
            <NotificationPage
                open={openNotifications}
                dismiss={dismissNotifications}
                onMessagesLoad={onMessagesLoad}
            />
        </>
    )
};


const useStyles = makeStyles((theme: Theme) => createStyles({

        logo: {
            height: 47,
            paddingRight: 16,
            borderRight: 'solid white 1px',
            marginRight: 16,
        },
        logoType: {
            height: 24,
        },
        main: {
            backgroundColor: '#046A38',
        },
        notificationIcon: {
            color: 'white',
        }
    })
);
